import React from 'react';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';

// import { addClassToIframe } from "./custom-component";
// export const onRouteUpdate = () => {
//   requestAnimationFrame(() => {
//     addClassToIframe();
//   });
// };
import VedioKeyComp from './src/components/VedioKeyComp/VedioKeyComp';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'VedioKeyComp',
        component: VedioKeyComp,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
